export const TestIds = {
  container: 'ces-partner-score-container',
  header: 'ces-partner-score-container-header',
  description: 'ces-partner-score-container-description',
  dataAvailability: 'ces-partner-score-data-availability',
  children: 'ces-partner-score-container-children',
};
